module.exports = __webpack_public_path__ + "img/examples-en-1.b022a2bc.jpg";